import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  address: {
    padding: '12px 14px',
  },
  field: {
    marginBottom: 30,
  },
  deliveryAddressContainer: {
    borderRadius: '10px',
    border: '1px solid #e1e1e1',
    '& > *:not(:last-child)': {
      borderBottom: '1px solid #e1e1e1',
    },
  },
  textField: {
    borderStyle: 'none',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  pickupHeader: {
    marginBottom: 20,
  },
}))

export default useStyles
